import { render, staticRenderFns } from "./drawer_weight.vue?vue&type=template&id=0910d9a4&scoped=true&"
import script from "./drawer_weight.vue?vue&type=script&lang=js&"
export * from "./drawer_weight.vue?vue&type=script&lang=js&"
import style0 from "./drawer_weight.vue?vue&type=style&index=0&id=0910d9a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0910d9a4",
  null
  
)

export default component.exports